import moment from 'moment';
import { getLanguage } from '../../../locales/i18n';

export const getDateTimeFormated = (
  dateString: any,
  hideTime: boolean = false
): string => {
  const date = new Date(dateString);
  const language = getLanguage();

  const options: any = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric'
  };

  const formattedDate = date.toLocaleDateString(language, options);

  if (hideTime) {
    return formattedDate;
  }

  const formattedTime = date.toLocaleTimeString(language, {
    hour: 'numeric',
    minute: '2-digit'
  });

  const formattedDateTime = `${formattedDate}, ${formattedTime}`;
  return formattedDateTime;
};

export const getTimeFormated = (dateString: any): string => {
  const date = new Date(dateString);
  const language = getLanguage();

  const formattedTime = date.toLocaleTimeString(language, {
    hour: 'numeric',
    minute: '2-digit'
  });

  return formattedTime;
};
export const getDateTimeFormattedMoment = (
  dateString: any,
  hideTime: boolean = false,
): string => {
  const m = moment.parseZone(dateString);
  const language = getLanguage();

  const date = m.locale(language).format('L'); // localized date

  if (hideTime) return date;

  const time = m.locale(language).format('LT'); // localized time
  return `${date}, ${time}`;
};